import * as XLSX from 'xlsx';

/**
 * Maps Excel data keys to database column names
 * Handles common variations like "Name" -> "item_name"
 */
const columnMap = {
  // Common mappings for Materials
  'Name': 'item_name',
  'Item Name': 'item_name',
  'ItemName': 'item_name',
  'Category': 'category',
  'SubCategory1': 'sub_category_1',
  'Sub Category 1': 'sub_category_1',
  'SubCategory2': 'sub_category_2',
  'Sub Category 2': 'sub_category_2',
  'StaminaCost': 'stamina_cost',
  'Stamina Cost': 'stamina_cost',
  'Level': 'level',
  'Location': 'location',
  'ReqMaterial': 'req_material',
  'Required Material': 'req_material',
  'ReqMatCost': 'req_mat_cost',
  'Required Material Cost': 'req_mat_cost',
  'ECost': 'e_cost',
  'E Cost': 'e_cost',
  
  // Common mappings for Items
  'SubCategory': 'sub_category',
  'Sub Category': 'sub_category',
  'Material1': 'material_1',
  'Material 1': 'material_1',
  'Qty1': 'qty_1',
  'Quantity 1': 'qty_1',
  'Material2': 'material_2',
  'Material 2': 'material_2',
  'Qty2': 'qty_2',
  'Quantity 2': 'qty_2'
};

export const parseExcelFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const rawJson = XLSX.utils.sheet_to_json(worksheet);

        // Map the keys to match our database schema
        const mappedData = rawJson.map(row => {
          const newRow = {};
          Object.keys(row).forEach(key => {
            const mappedKey = columnMap[key] || key.toLowerCase().replace(/\s+/g, '_');
            newRow[mappedKey] = row[key];
          });
          return newRow;
        });

        resolve(mappedData);
      } catch (err) {
        reject(err);
      }
    };
    reader.onerror = (err) => reject(err);
    reader.readAsBinaryString(file);
  });
};